export default class FiltersStorage {

    static getFiltersParam(param)
    {
        let filters = JSON.parse(sessionStorage.getItem('filters'));

        if (filters === null || !filters[param]) {
            return null
        }

        return filters[param]
    }

    static hasFiltersStored(){
        let filters = JSON.parse(sessionStorage.getItem('filters'));

        return filters !== null
    }

    static saveFilters(data){
        sessionStorage.setItem('filters', JSON.stringify(data))
    }

    static getFilters(){
        return JSON.parse(sessionStorage.getItem('filters'));
    }

    static wipeOut(){
        sessionStorage.removeItem('filters');
    }

}